import { useHistory } from 'react-router-dom'

import { useAppSelector } from '../../app/hooks'
import { POI, Scene } from '../../shared/types'
import { SCENE_ROUTE } from '../../shared/constants/global'

export const useActions = () => {
  const history = useHistory()

  const mapId = useAppSelector((state) => state.maps.activeMapId)

  const handlePOIClick = (poi?: POI) => {
    const targetMapId = poi?.map ?? mapId
    if (!targetMapId || !poi) {
      console.warn('Missing mapId or poi for POI:', poi?.id)
      return
    }
    history.push(`/map/${targetMapId}/poi/${poi?.id}`)
  }

  const handleSceneClick = (scene?: Scene) => {
    scene?.id && history.push(`/${SCENE_ROUTE}/${scene.id}`)
  }

  return {
    handlers: {
      handlePOIClick,
      handleSceneClick,
    },
  }
}
